import { Student } from "@/types/student";

export const getAvailableGrades = (
  students: Student[],
  enabledStages: any[],
  hasMultipleStages: boolean,
  selectedStage: string,
  orderedStages: any[]
) => {
  // إذا لم تكن هناك مراحل مُفعلة، أظهر جميع صفوف الطلاب
  // if (enabledStages.length === 0) {
  //   const studentGrades = [...new Set(students.map((s) => s.grade))].filter(
  //     (grade) => grade && grade.trim()
  //   );
  //   return studentGrades;
  // }

  // إذا تم اختيار مرحلة، أظهر صفوف تلك المرحلة فقط
  if (selectedStage) {
    const stage = orderedStages.find((s: any) => s.id === selectedStage);
    if (stage && stage.grades) {
      const stageGrades = stage.grades
        .map((g: any) => g.name)
        .filter((grade) => grade && grade.trim());
      return stageGrades.sort((a, b) => a.localeCompare(b, "ar"));
    }
    return [];
  }

  // إذا لم يتم اختيار مرحلة، أظهر جميع الصفوف من المراحل المُفعلة
  const allStageGrades = enabledStages
    .flatMap((stage: any) =>
      stage.grades ? stage.grades.map((g: any) => g.name) : []
    )
    .filter((grade) => grade && grade.trim());

  const uniqueGrades = [...new Set(allStageGrades)];
  return uniqueGrades.sort((a, b) => a.localeCompare(b, "ar"));
};

export const getAvailableSections = (
  selectedGrade: string,
  students: Student[],
  enabledStages: any[],
  hasMultipleStages: boolean,
  selectedStage: string,
  orderedStages: any[]
) => {
  if (!selectedGrade || selectedGrade==="") {
    return [];
  }

  // أولاً، جرب الحصول على الأقسام من الطلاب الفعليين
  // if (selectedGrade === "") {
  // const studentsInGrade = students.filter(
  //   (student) => student.grade === selectedGrade
  // );
  // const studentSections = [
  //   ...new Set(
  //     studentsInGrade
  //       .map((student) => student.section)
  //       .filter((section) => section && section.trim())
  //   ),
  // ];

  // // إذا وُجدت أقسام من الطلاب، استخدمها
  // if (studentSections.length > 0) {
  //   return studentSections.sort((a, b) => a.localeCompare(b, "ar"));
  // }
  // }

  // إذا لم توجد مراحل مفعلة أو كان هناك مرحلة واحدة فقط، أظهر قسم افتراضي
  // if (!hasMultipleStages || enabledStages.length === 0) {
  //   return ["أ"];
  // }

  // إذا تم اختيار مرحلة، ابحث عن الشعب في تلك المرحلة فقط
  // if (selectedStage && selectedGrade !== "") {
  //   const stage = orderedStages.find((s: any) => s.id === selectedStage);
  //   if (stage && stage.grades) {
  //     const grade = stage.grades.find((g: any) => g.name === selectedGrade);
  //     if (grade && grade.sections) {
  //       const stageSections = grade.sections.filter(
  //         (section) => section && section.trim()
  //       );
  //       return stageSections.length > 0
  //         ? stageSections.sort((a, b) => a.localeCompare(b, "ar"))
  //         : ["أ"];
  //     }
  //   }
  //   return ["أ"];
  // }
  let sections = [];
  orderedStages.forEach((stage) => {
    if (stage && stage.grades) {
      const grade = stage.grades.find((g: any) => g.name === selectedGrade);

      if(grade) {
        sections = grade?.sections ?? [];
      }
    }
  });
  
  return sections.length > 0 ? sections : ["أ"];
};
